export default __webpack_public_path__ + "static/media/2641.10865767.png";